import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {
  selectedIds: [],
  bundleSummary: null,
  instantBundleSummary: null,
  bundleTrackingId: null,
  isBundlingInProgress: false
};

const getBundleSummarySuccess = (draft, action) => {
  const {
    bundleSummary
  } = action.payload;
  draft.bundleSummary = bundleSummary;
};

const getInstantBundleSummarySuccess = (draft, action) => {
  const {
    instantBundleSummary
  } = action.payload;
  draft.instantBundleSummary = instantBundleSummary;
};

const setSelectedItems = (draft, action) => {
  const {
    itemIds
  } = action.payload;
  draft.selectedIds = itemIds;
};

const startBundling = draft => {
  draft.isBundlingInProgress = true;
};

const resumeBundling = (draft, action) => {
  draft.isBundlingInProgress = true;
  draft.bundleTrackingId = action.payload.bundleTrackingId;
};

const setBundleTrackingId = (draft, action) => {
  draft.bundleTrackingId = action.payload.bundleTrackingId;
};

const bundleSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    startBundling,
    resumeBundling,
    setSelectedItems,
    setBundleTrackingId,
    getBundleSummarySuccess,
    getInstantBundleSummarySuccess
  }
});
export const {
  actions
} = bundleSlice;
export const plug = {
  [stateName]: bundleSlice.reducer
};
export default bundleSlice.reducer;